import { useCallback, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import {
  AllCommunityModule,
  CellValueChangedEvent,
  ColDef,
  ModuleRegistry,
  themeQuartz,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import { FornecCiclo } from "../types";
import "./ciclosGrid.css";

ModuleRegistry.registerModules([AllCommunityModule]);

const defaultColDef: ColDef = {
  sortable: false,
  filter: false,
  resizable: true,
  suppressMovable: true,
  cellStyle: { padding: "2px" },
  headerClass: "header-sem-padding",
};

export const CiclosGrid = () => {
  const { setValue } = useFormContext();
  const ciclos = useWatch({ name: "ciclos" }) as FornecCiclo[] | undefined;

  const columnDefs = useMemo<ColDef<FornecCiclo>[]>(
    () => [
      { field: "status", headerName: "Status", flex: 1.2, editable: false },
      { field: "sigla", headerName: "Sigla", flex: 4, editable: false },
      {
        field: "dias",
        headerName: "Dias",
        flex: 2,
        editable: true,
        type: "numericColumn",
        valueParser: (params) => {
          const n = Number(params.newValue);
          return Number.isFinite(n) ? n : params.oldValue;
        },
      },
    ],
    [],
  );

  const onCellValueChanged = useCallback(
    (ev: CellValueChangedEvent<FornecCiclo>) => {
      const rows: FornecCiclo[] = [];
      ev.api.forEachNode((node) => {
        if (node.data) rows.push(node.data);
      });
      setValue("ciclos", rows, { shouldDirty: true });
    },
    [setValue],
  );

  return (
    <AgGridReact<FornecCiclo>
      theme={themeQuartz}
      rowData={ciclos ?? []}
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
      getRowId={(params) => String(params.data.status)}
      onCellValueChanged={onCellValueChanged}
      singleClickEdit
      stopEditingWhenCellsLoseFocus
      domLayout="autoHeight"
      localeText={{ noRowsToShow: "Sem itens" }}
    />
  );
};
